// Apply icons to custom ::before and ::after elements
// This slows performance and is therefore not recommended if it can be avoided.
// window.FontAwesomeConfig.searchPseudoElements = true;

// Style
// require('./social');
require('./solid');
// require('./regular');
require('./light');



// WEBPACK FOOTER //
// ./themes/base/js/fontawesome/index.js